// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1K5-X","validationTips":"StatementDescriptor_validationTips__1UyvO"};